import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { LGoButton } from "@/ui/branded";
import type { FirstStep } from "../hooks/useFirstSteps";

/** Guidance, not a gate: every screen it names stays reachable from the nav and
 *  stays authorable, per `lastgo-api/docs/partner-ia-v2.md`. */
export function FirstSteps({ steps }: { steps: FirstStep[] }) {
  return (
    <section className="space-y-6" aria-labelledby="first-steps">
      <div className="space-y-1">
        <h2 id="first-steps" className="font-display text-2xl font-semibold tracking-tight">
          Než vás zákazníci uvidí
        </h2>
        <p className="text-sm text-muted-foreground max-w-prose">
          Tři kroky v tomto pořadí. Nic z toho vám nebrání pracovat dál — slevové termíny si můžete
          připravit kdykoliv.
        </p>
      </div>

      <ol className="space-y-3">
        {steps.map((step, index) => (
          <li
            key={step.to}
            className="flex gap-4 rounded-xl border border-border px-5 py-4 items-start"
          >
            <span
              aria-hidden="true"
              className={
                step.isDone
                  ? "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground"
                  : "flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-border text-muted-foreground tabular-nums text-sm"
              }
            >
              {step.isDone ? <Check className="h-4 w-4" /> : index + 1}
            </span>
            <div className="space-y-2 min-w-0">
              <h3 className="font-semibold">
                {step.title}{" "}
                <span className="font-normal text-muted-foreground text-sm">
                  · {step.isDone ? "Hotovo" : "Zbývá"}
                </span>
              </h3>
              <p className="text-sm text-muted-foreground max-w-prose">{step.body}</p>
              <LGoButton asChild variant={step.isDone ? "ghost" : "secondary"}>
                <Link to={step.to}>{step.cta}</Link>
              </LGoButton>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
